import { useEffect } from "react";
import Lenis from "lenis";

// Module-scoped so the ScrollToTop helper in App.js can access it
export let lenisInstance = null;

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
  return children;
}
